import React from 'react';
import { DAPrice } from '@components';

const TtfDAPrice = () => {
    return (
        <DAPrice
            title="TTF DA Prices"
            rootPath="/media/files/csv/index/ttf/"
            breadcrumbRootLabel="ttf-da-prices"
            downloadProduct="TTF"
            downloadType="da_index"
            searchPlaceholders={{
                0: 'Search currency folder (e.g. EUR)',
                1: 'Search year folder (e.g. 2026)',
                2: 'Search month folder (e.g. 03 or March)',
                3: 'Search filename (e.g. 01.03.2026.csv)',
                default: 'Search filename or date'
            }}
            levelLabels={{
                0: 'Currency',
                1: 'Year',
                2: 'Month',
                3: 'File',
                default: 'Folder'
            }}
        />
    );
};

export default TtfDAPrice;
